import React, { useState, useEffect } from "react";

// mui
import { useTheme } from "@mui/styles";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";

export default function ProgressBar({ percentComplete }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "absolute",
        backgroundColor: "white !important",
        opacity: "0.9",
        borderRadius: "5px",
        padding: "2px",
        width: "300px",
        bottom: "28px",
        display: "block",
        [theme.breakpoints.down("md")]: {
          width: "60%",
        },
      }}
    >
      <Box
        tabIndex={0}
        style={{
          margin: theme.spacing(0.5, 1),
          backgroundColor: "white",
          // opacity: 0.9,
          borderRadius: "5px",
        }}
      >
        {`${percentComplete}% Completed`}
      </Box>
      <LinearProgress
        sx={{ borderRadius: theme.spacing(1) }}
        variant="determinate"
        value={percentComplete}
      />
    </Box>
  );
}
